
import React from 'react';

export default function Demerits() {
  const demerits = [
    {
      icon: 'ri-calendar-line',
      title: '29歳以下限定',
      description:
        '申込み日時点で満18歳以上29歳以下の方のみ申込み可能。30歳以上の方は通常のdカード GOLDをご検討ください。',
    },
    {
      icon: 'ri-refresh-line',
      title: '30歳以降は自動切り替え',
      description:
        '満30歳以降のカード有効期限満了時に、年会費11,000円のdカード GOLDに自動的に切り替わります。',
    },
    {
      icon: 'ri-user-line',
      title: 'ドコモユーザー以外はメリット薄',
      description:
        'ドコモ料金5%還元やahamo+5GBなど、主要特典はドコモユーザー向け。他キャリアユーザーにはメリットが限定的。',
    },
    {
      icon: 'ri-money-yen-circle-line',
      title: '条件未達成だと年会費発生',
      description:
        '22歳以下、年間30万円利用、ドコモプラン契約のいずれも満たさない場合、年会費3,300円がかかります。',
    },
  ];

  // Defensive rendering – ensure demerits is an array before mapping
  if (!Array.isArray(demerits) || demerits.length === 0) {
    return (
      <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 text-center text-gray-600">
          デメリット情報が取得できませんでした。
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-[#003366] mb-4">
          dカード GOLD Uのデメリット
        </h2>
        <p className="text-center text-gray-600 mb-12">
          申し込み前に確認しておきたいポイント
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {demerits.map((demerit, index) => (
            <div
              key={index}
              className="bg-white border border-gray-200 rounded-xl p-6 hover:shadow-lg transition-all"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className={`${demerit.icon} text-xl text-gray-600`}></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#003366] mb-2">
                    {demerit.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {demerit.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
